import { render, staticRenderFns } from "./SalesByChannel.vue?vue&type=template&id=701dad2c"
import script from "./SalesByChannel.vue?vue&type=script&lang=js"
export * from "./SalesByChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports